// Triggers a real browser file download for a given URL.
//
// Behaviour per environment:
//   - Desktop Chrome / Firefox / Edge / Safari: native "Save As" dialog
//   - iOS Safari (real phone): opens Share sheet with "Save to Files"
//   - Android Chrome (real phone): native download notification
//
// NOTE: this DOES NOT work inside the Emergent macOS Preview window because
// that webview is a dev tool and does not implement OS-level downloads.
// To verify the download flow, always test on a real device browser.
export function forceDownload(url, filename) {
  const a = document.createElement("a");
  a.href = url;
  if (filename) a.download = filename;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
